package ai.flowstorm.studio.resources

import ai.flowstorm.common.resources.AbstractResource
import ai.flowstorm.studio.model.Alternatives
import io.kvision.rest.HttpMethod
import kotlinx.serialization.builtins.serializer

object AlternativeGeneratorResource: AbstractResource<Alternatives>("/alternatives", Alternatives.serializer()) {
    suspend fun generateAlternatives(currentAlternatives: Alternatives): Alternatives {
        return remoteCall("", currentAlternatives, HttpMethod.POST)
    }

    suspend fun saveAlternatives(alternatives: Alternatives): Alternatives {
        return remoteCall("/save", alternatives, HttpMethod.POST)
    }
}